module.exports = __webpack_public_path__ + "static/Calluna-Regular-webfont-b55edec85143cedcf0ebcfccb2dc383d.woff";